import { render, staticRenderFns } from "./formContainer.vue?vue&type=template&id=f3b55448&"
import script from "./formContainer.vue?vue&type=script&lang=js&"
export * from "./formContainer.vue?vue&type=script&lang=js&"
import style0 from "./formContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "formContainer.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VForm,
  VLayout,
})
